export const dynamicSort = ( property: string, order = 1 ) => {
    //  eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (a: any, b: any) {
        const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * order;
    }
}
